import {
  OrganismeFichierDto,
  OrganismeFichierProjection,
  OrganismeFichierType,
  useGetOrganismeFichiersQuery,
} from '@common/services';
import { groupBy } from '@common/utils';

export function useOfaFichiers(args: UseOfaFichiersConfig) {
  const { organismeId } = args;

  const { data: fichiers, isLoading } = useGetOrganismeFichiersQuery({
    projection: OrganismeFichierProjection.LIGHT,
    id: organismeId,
  });

  const filesMap = groupBy<OrganismeFichierType, OrganismeFichierDto>('type', fichiers?.content);

  return { filesMap, isLoading };
}

interface UseOfaFichiersConfig {
  organismeId: number;
}